export default __webpack_public_path__ + "33d2f89e0616126658af360175dc93f4.ttf";